/* eslint-disable import/prefer-default-export */
export const dteTypeToLabel = {
  33: 'Factura afecta',
  34: 'Factura exenta',
  61: 'Nota de crédito',
  56: 'Nota de débito',
};
